import { MD5 } from 'crypto-js';
import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import FormModal from './FormModal';
import { deleteArquivo } from '../redux/actions';
import { UAParser } from 'ua-parser-js';

function ModalApagarArquivo(props) {

    const backgroudClass = (
        props.tema === 'escuro' ?
            'bg-dark text-white border-neutral-700' :
            'bg-light'
    )

    const dispatch = useDispatch()
    const [browserInfo, setBrowserInfo] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    // Helper para timeout nas requisições
    const fetchWithTimeout = (url, options = {}, timeout = 3000) => {
        return Promise.race([
            fetch(url, options),
            new Promise((_, reject) =>
                setTimeout(() => reject(new Error('timeout')), timeout)
            )
        ]);
    };

    useEffect(() => {
        if (props.show) {
            setBrowserInfo(null)
            setIsLoading(true)

            const parser = new UAParser();
            const result = parser.getResult();
            const os = `${result.os.name}`;
            const browser = `${result.browser.name} ${result.browser.version}`;

            fetchWithTimeout('https://api.ipify.org?format=json')
                .then(response => response.json())
                .then(data => {
                    const ip = data.ip;

                    return fetchWithTimeout('https://ipapi.co/json/');
                })
                .then(response => response.json())
                .then(data => {
                    const location = `${data.city}, ${data.country_name}`;
                    const latitude = data.latitude;
                    const longitude = data.longitude;

                    const infoString = `Sistema Operacional: ${os}\n` +
                        `Navegador: ${browser}\n` +
                        `Endereço IP: ${data.ip || ''}\n` +
                        `Localização: ${location} (Lat: ${latitude}, Lon: ${longitude})\n` +
                        `Linguagem: ${navigator.language}`;

                    setBrowserInfo(infoString);
                    setIsLoading(false);
                })
                .catch(error => {
                    console.error("Erro ao obter IP ou localização:", error);
                    const infoString = `Sistema Operacional: ${os}\n` +
                        `Navegador: ${browser}\n` +
                        `Linguagem: ${navigator.language}`;

                    setBrowserInfo(infoString);
                    setIsLoading(false);
                });
        }
    }, [props.show]);

    function apagaArquivo() {
        props.handleShow(false)
        dispatch(deleteArquivo(
            props.inscricao,
            props.nomeDoArquivo,
            props.tamanhoArquivo,
            props.idHistorico,
            props.tarefaID,
            props.numeroLinhas,
            props.pagina,
            browserInfo
        ));
    }

    return (
        <Modal show={props.show} onHide={() => { props.handleShow(false) }}>
            <Modal.Header closeButton className={`${backgroudClass}`}>
                <Modal.Title>Apagar Arquivo</Modal.Title>
            </Modal.Header>
            <Modal.Body className={backgroudClass}>
                <h1 className='text-xl'>Essa função vai deletar o arquivo e o histórico selecionado, deseja continuar?</h1>
            </Modal.Body>
            <Modal.Footer className={`${backgroudClass}`}>
                <Button
                    variant="primary"
                    onClick={() => { props.handleShow(false) }}
                    className={props.tema === 'claro' ? 'text-black' : ''}
                >
                    Cancelar
                </Button>
                <Button
                    variant="warning"
                    onClick={apagaArquivo}
                    className={props.tema === 'claro' ? 'text-black' : 'text-white'}
                    disabled={isLoading || !browserInfo}
                >
                    {isLoading ? 'Aguarde...' : 'Confirmar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

const mapStateToProps = (state) => {
    return {
        tema: state.appReducer.tema,
        dadosUsuario: state.appReducer.dadosUsuario,
        inscricao: state.appReducer.dadosUsuario.inscricao,
        tarefaID: state.appReducer.tarefaID,
        numeroLinhas: state.appReducer.numeroLinhas,
        pagina: state.appReducer.pagina
    }
}

export default connect(mapStateToProps, null)(ModalApagarArquivo);
